import { useQueryParams } from '../../../hooks/UseQueryParams';
import { useUserContext } from '../../../contexts/UserContext';
import { AUTHENTICATION_STATUSES } from '../../PageWrappers/AdDetails/types';
import {
  FreeHistoryCheckTrackingSource,
  useFreeHistoryCheckAnalytics,
} from '../FreeHistoryCheckAnalytics.hook';

export const MODAL_QUERY_KEY = 'modal';
export const MODAL_QUERY_VALUE = 'free-history-check';

export type UseFreeHistoryCheckModal = {
  isOpen: boolean;
  open: (trackingSource: FreeHistoryCheckTrackingSource) => void;
  close: () => void;
};

export const useFreeHistoryCheckModal = (): UseFreeHistoryCheckModal => {
  const { checkIfQueryIsPresent, removeQueries, addQueries } = useQueryParams();
  const { handleLogin, status } = useUserContext();
  const { setTrackingSource } = useFreeHistoryCheckAnalytics();

  const isOpen =
    checkIfQueryIsPresent(MODAL_QUERY_KEY, MODAL_QUERY_VALUE) &&
    status === AUTHENTICATION_STATUSES.AUTHENTICATED;

  const addModalQueryToUrl = () =>
    addQueries({ [MODAL_QUERY_KEY]: MODAL_QUERY_VALUE });

  const open = (trackingSource: FreeHistoryCheckTrackingSource) => {
    // Set the tracking source for analytics - this value is retrieved in the modal form hook and used for tracking events
    setTrackingSource(trackingSource);
    if (
      status === AUTHENTICATION_STATUSES.AUTHENTICATED ||
      status === AUTHENTICATION_STATUSES.LOADING
    ) {
      addModalQueryToUrl();
    } else {
      const url = new URL(location.href);
      url.searchParams.set(MODAL_QUERY_KEY, MODAL_QUERY_VALUE);
      handleLogin(url.href);
    }
  };

  const close = () => {
    removeQueries([MODAL_QUERY_KEY]);
  };

  return {
    isOpen,
    open,
    close,
  };
};
